// src/features/bookings/components/BookingDetail/tabs/BookingTypeDetailsTab.jsx
import React from 'react';
import { formatNumber } from '../../../../../shared/utils/formatters';

// ── تفاصيل التخرج ───────────────────────────────────────────
const GraduationDetails = ({ details, isEditing, onInputChange, offerHandlers, styles }) => {
  if (!details) return <p className={styles.emptyTab}>لا توجد تفاصيل.</p>;

  const totalOffers = (details.offers || []).reduce(
    (s, o) => s + parseFloat(o.offer_subtotal || 0), 0
  );
  const totalStudents = (details.offers || []).reduce(
    (s, o) => s + parseInt(o.num_students || 0), 0
  );
  const totalPrinting = (details.offers || []).reduce(
    (s, o) => s + (parseFloat(o.printing_cost || 0) * parseInt(o.num_students || 0)), 0
  );

  return (
    <>
      {/* المعلومات الأساسية */}
      <div className={styles.infoGrid} style={{ marginBottom: '24px' }}>
        <div className={styles.infoCell}>
          <span className={styles.icLabel}>الكلية</span>
          {isEditing ? (
            <input className={styles.editInput} type="text"
              value={details.college || ''}
              onChange={e => onInputChange('college', e.target.value, 'graduation_details')} />
          ) : <span className={styles.icVal}>{details.college || '—'}</span>}
        </div>
        <div className={styles.infoCell}>
          <span className={styles.icLabel}>القسم</span>
          {isEditing ? (
            <input className={styles.editInput} type="text"
              value={details.department || ''}
              onChange={e => onInputChange('department', e.target.value, 'graduation_details')} />
          ) : <span className={styles.icVal}>{details.department || '—'}</span>}
        </div>
        <div className={styles.infoCell}>
          <span className={styles.icLabel}>اسم الممثل</span>
          {isEditing ? (
            <input className={styles.editInput} type="text"
              value={details.representative_name || ''}
              onChange={e => onInputChange('representative_name', e.target.value, 'graduation_details')} />
          ) : <span className={styles.icVal}>{details.representative_name || '—'}</span>}
        </div>
        <div className={styles.infoCell}>
          <span className={styles.icLabel}>رقم الممثل</span>
          {isEditing ? (
            <input className={styles.editInput} type="text"
              value={details.representative_phone || ''}
              onChange={e => onInputChange('representative_phone', e.target.value, 'graduation_details')} />
          ) : <span className={styles.icVal}>{details.representative_phone || '—'}</span>}
        </div>
      </div>

      {/* الإيرادات الإضافية */}
      <div className={styles.infoGrid} style={{ marginBottom: '24px' }}>
        <div className={styles.infoCell}>
          <span className={styles.icLabel}>عدد الصور الإضافية</span>
          {isEditing ? (
            <input className={styles.editInput} type="number"
              value={details.extra_photos_count || ''}
              onChange={e => onInputChange('extra_photos_count', e.target.value, 'graduation_details')} />
          ) : <span className={styles.icVal}>{details.extra_photos_count || '0'}</span>}
        </div>
        <div className={styles.infoCell}>
          <span className={styles.icLabel}>سعر الصورة الإضافية</span>
          {isEditing ? (
            <input className={styles.editInput} type="number" step="any"
              value={details.extra_photo_price || ''}
              onChange={e => onInputChange('extra_photo_price', e.target.value, 'graduation_details')} />
          ) : <span className={styles.icVal}>{formatNumber(details.extra_photo_price || 0)}</span>}
        </div>
        <div className={styles.infoCell}>
          <span className={styles.icLabel}>إيرادات أخرى</span>
          {isEditing ? (
            <input className={styles.editInput} type="number" step="any"
              value={details.other_revenues || ''}
              onChange={e => onInputChange('other_revenues', e.target.value, 'graduation_details')} />
          ) : <span className={styles.icVal}>{formatNumber(details.other_revenues || 0)}</span>}
        </div>
        <div className={styles.infoCell}>
          <span className={styles.icLabel}>إضافات أخرى</span>
          {isEditing ? (
            <input className={styles.editInput} type="number" step="any"
              value={details.additional_revenues || ''}
              onChange={e => onInputChange('additional_revenues', e.target.value, 'graduation_details')} />
          ) : <span className={styles.icVal}>{formatNumber(details.additional_revenues || 0)}</span>}
        </div>
      </div>

      {/* جدول العروض */}
      <div style={{ border: '0.5px solid var(--border-default)', borderRadius: 'var(--radius-lg)', overflow: 'hidden' }}>
        <table className={styles.detailsTable} style={{ border: 'none', borderRadius: 0 }}>
          <thead>
            <tr>
              <th>العرض</th>
              <th>عدد الطلاب</th>
              <th>سعر العرض</th>
              <th>تكلفة الطبعة</th>
              <th>الإجمالي</th>
              {isEditing && <th></th>}
            </tr>
          </thead>
          <tbody>
            {(details.offers || []).map((offer, i) => (
              <tr key={offer.id || i}>
                <td>
                  {isEditing ? (
                    <input className={styles.editInput} name="name"
                      value={offer.name || ''} style={{ minWidth: '120px' }}
                      onChange={e => offerHandlers.handleOfferChange(i, e)} />
                  ) : (offer.name || `عرض ${i + 1}`)}
                </td>
                <td>
                  {isEditing ? (
                    <input className={styles.editInput} type="number" name="num_students"
                      value={offer.num_students || ''} style={{ width: '80px' }}
                      onChange={e => offerHandlers.handleOfferChange(i, e)} />
                  ) : offer.num_students}
                </td>
                <td>
                  {isEditing ? (
                    <input className={styles.editInput} type="number" step="any" name="offer_price"
                      value={offer.offer_price || ''} style={{ width: '100px' }}
                      onChange={e => offerHandlers.handleOfferChange(i, e)} />
                  ) : formatNumber(offer.offer_price)}
                </td>
                <td>
                  {isEditing ? (
                    <input className={styles.editInput} type="number" step="any" name="printing_cost"
                      value={offer.printing_cost || ''} style={{ width: '100px' }}
                      onChange={e => offerHandlers.handleOfferChange(i, e)} />
                  ) : formatNumber(offer.printing_cost)}
                </td>
                <td style={{ fontWeight: 'var(--font-semibold)', color: 'var(--text-heading)' }}>
                  {formatNumber(offer.offer_subtotal || 0)}
                </td>
                {isEditing && (
                  <td>
                    {(details.offers || []).length > 1 && (
                      <button
                        type="button"
                        onClick={() => offerHandlers.removeOffer(i)}
                        style={{
                          background: 'var(--color-danger-subtle)',
                          color: 'var(--color-danger-text)',
                          border: '0.5px solid var(--color-danger-border)',
                          borderRadius: 'var(--radius-sm)',
                          padding: '2px 8px',
                          fontSize: '11px',
                          cursor: 'pointer',
                          fontFamily: 'var(--font-family)',
                        }}
                      >
                        حذف
                      </button>
                    )}
                  </td>
                )}
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <td><strong>المجموع</strong></td>
              <td><strong>{totalStudents}</strong></td>
              <td></td>
              <td style={{ color: 'var(--color-danger)', fontWeight: 'var(--font-extrabold)' }}>
                {formatNumber(totalPrinting)}
              </td>
              <td style={{ color: 'var(--color-success)', fontWeight: 'var(--font-extrabold)' }}>
                {formatNumber(totalOffers)}
              </td>
              {isEditing && <td></td>}
            </tr>
          </tfoot>
        </table>
      </div>

      {isEditing && (
        <button
          type="button"
          className={styles.addBtn}
          onClick={offerHandlers.addOffer}
        >
          + إضافة عرض آخر
        </button>
      )}
    </>
  );
};

// ── تفاصيل العرس ────────────────────────────────────────────
const WeddingDetails = ({ details, isEditing, onInputChange, styles }) => {
  if (!details) return <p className={styles.emptyTab}>لا توجد تفاصيل.</p>;
  return (
    <div className={styles.infoGrid}>
      <div className={styles.infoCell}>
        <span className={styles.icLabel}>اسم العريس</span>
        {isEditing ? (
          <input className={styles.editInput} type="text"
            value={details.groom_name || ''}
            onChange={e => onInputChange('groom_name', e.target.value, 'wedding_details')} />
        ) : <span className={styles.icVal}>{details.groom_name || '—'}</span>}
      </div>
      <div className={styles.infoCell}>
        <span className={styles.icLabel}>اسم العروس</span>
        {isEditing ? (
          <input className={styles.editInput} type="text"
            value={details.bride_name || ''}
            onChange={e => onInputChange('bride_name', e.target.value, 'wedding_details')} />
        ) : <span className={styles.icVal}>{details.bride_name || '—'}</span>}
      </div>
      {details.package_details && (
        <div className={`${styles.infoCell} ${styles.infoCellFull}`}>
          <span className={styles.icLabel}>تفاصيل الباقة</span>
          {isEditing ? (
            <textarea className={styles.editTextarea} rows={3}
              value={details.package_details}
              onChange={e => onInputChange('package_details', e.target.value, 'wedding_details')} />
          ) : <span className={styles.icValNote}>{details.package_details}</span>}
        </div>
      )}
    </div>
  );
};

// ── تفاصيل الأطفال ──────────────────────────────────────────
const KidsDetails = ({ details, isEditing, onInputChange, styles }) => {
  if (!details) return <p className={styles.emptyTab}>لا توجد تفاصيل.</p>;
  return (
    <div className={styles.infoGrid}>
      <div className={styles.infoCell}>
        <span className={styles.icLabel}>اسم الطفل</span>
        {isEditing ? (
          <input className={styles.editInput} type="text"
            value={details.child_name || ''}
            onChange={e => onInputChange('child_name', e.target.value, 'kids_details')} />
        ) : <span className={styles.icVal}>{details.child_name || '—'}</span>}
      </div>
      <div className={styles.infoCell}>
        <span className={styles.icLabel}>عمر الطفل</span>
        {isEditing ? (
          <input className={styles.editInput} type="text"
            value={details.child_age || ''}
            onChange={e => onInputChange('child_age', e.target.value, 'kids_details')} />
        ) : <span className={styles.icVal}>{details.child_age || '—'}</span>}
      </div>
      <div className={styles.infoCell}>
        <span className={styles.icLabel}>الجنس</span>
        {isEditing ? (
          <select value={details.child_gender || 'boy'}
            onChange={e => onInputChange('child_gender', e.target.value, 'kids_details')}>
            <option value="boy">ولد</option>
            <option value="girl">بنت</option>
          </select>
        ) : <span className={styles.icVal}>{details.child_gender === 'boy' ? 'ولد' : 'بنت'}</span>}
      </div>
      <div className={styles.infoCell}>
        <span className={styles.icLabel}>ثيم الجلسة</span>
        {isEditing ? (
          <input className={styles.editInput} type="text"
            value={details.session_theme || ''}
            onChange={e => onInputChange('session_theme', e.target.value, 'kids_details')} />
        ) : <span className={styles.icVal}>{details.session_theme || '—'}</span>}
      </div>
    </div>
  );
};

// ── تفاصيل المناسبة ──────────────────────────────────────────
const EventDetails = ({ details, isEditing, onInputChange, styles }) => {
  if (!details) return <p className={styles.emptyTab}>لا توجد تفاصيل.</p>;
  return (
    <div className={styles.infoGrid}>
      <div className={styles.infoCell}>
        <span className={styles.icLabel}>اسم المناسبة</span>
        {isEditing ? (
          <input className={styles.editInput} type="text"
            value={details.event_name || ''}
            onChange={e => onInputChange('event_name', e.target.value, 'event_details')} />
        ) : <span className={styles.icVal}>{details.event_name || '—'}</span>}
      </div>
      <div className={styles.infoCell}>
        <span className={styles.icLabel}>عدد الحضور المتوقع</span>
        {isEditing ? (
          <input className={styles.editInput} type="number"
            value={details.expected_attendees || ''}
            onChange={e => onInputChange('expected_attendees', e.target.value, 'event_details')} />
        ) : <span className={styles.icVal}>{details.expected_attendees || '—'}</span>}
      </div>
      {details.event_schedule && (
        <div className={`${styles.infoCell} ${styles.infoCellFull}`}>
          <span className={styles.icLabel}>جدول الفعالية</span>
          {isEditing ? (
            <textarea className={styles.editTextarea} rows={4}
              value={details.event_schedule}
              onChange={e => onInputChange('event_schedule', e.target.value, 'event_details')} />
          ) : <span className={styles.icValNote}>{details.event_schedule}</span>}
        </div>
      )}
    </div>
  );
};

// ── المكوّن الرئيسي ──────────────────────────────────────────
const BookingTypeDetailsTab = ({ booking, editedData, isEditing, onInputChange, offerHandlers, styles }) => {
  const data = isEditing ? editedData : booking;

  const TYPE_LABELS = {
    graduation:        'تفاصيل حجز التخرج',
    wedding:           'تفاصيل حجز العرس',
    kids:              'تفاصيل حجز الأطفال',
    event:             'تفاصيل المناسبة',
    special:           'تفاصيل طلب خاص',
    digital_marketing: 'تفاصيل التسويق الإلكتروني',
  };

  const noDetails = ['special', 'digital_marketing'].includes(booking.booking_type);

  if (noDetails) {
    return (
      <p className={styles.emptyTab}>
        لا توجد تفاصيل إضافية لهذا النوع من الحجوزات.
      </p>
    );
  }

  return (
    <>
      <h3 style={{
        fontSize: 'var(--font-size-md)',
        fontWeight: 'var(--font-semibold)',
        color: 'var(--text-heading)',
        marginBottom: 'var(--space-5)',
        paddingBottom: 'var(--space-3)',
        borderBottom: '0.5px solid var(--border-default)',
      }}>
        {TYPE_LABELS[booking.booking_type] ?? 'تفاصيل الحجز'}
      </h3>

      {booking.booking_type === 'graduation' && (
        <GraduationDetails
          details={data.graduation_details}
          isEditing={isEditing}
          onInputChange={onInputChange}
          offerHandlers={offerHandlers}
          styles={styles}
        />
      )}

      {booking.booking_type === 'wedding' && (
        <WeddingDetails
          details={data.wedding_details}
          isEditing={isEditing}
          onInputChange={onInputChange}
          styles={styles}
        />
      )}

      {booking.booking_type === 'kids' && (
        <KidsDetails
          details={data.kids_details}
          isEditing={isEditing}
          onInputChange={onInputChange}
          styles={styles}
        />
      )}

      {booking.booking_type === 'event' && (
        <EventDetails
          details={data.event_details}
          isEditing={isEditing}
          onInputChange={onInputChange}
          styles={styles}
        />
      )}
    </>
  );
};

export default BookingTypeDetailsTab;